import { render } from "./ConsPerf.vue?vue&type=template&id=28fb9aeb&scoped=true"
import script from "./ConsPerf.vue?vue&type=script&lang=js"
export * from "./ConsPerf.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=28fb9aeb&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fb9aeb"]])

export default __exports__